import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import List from "components/menu/master-files/suppliers/list";

const StoresRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={List}
            />
        </Switch>
    </div>
);

export default connect()(StoresRouter);
